<template>
  <div class="client navigation">
    <v-list class="pt-0" dense>
      <v-divider />
      <!-- Dashboard -->
      <!-- <v-list-tile
      key="dashboard"
      to="/dashboard"
      @click="toggleDrawer"
      :active-class="themes.client.light.link">>
      <v-list-tile-action><v-icon>mdi-view-dashboard</v-icon></v-list-tile-action>
      <v-list-tile-content><v-list-tile-title>Dashboard</v-list-tile-title></v-list-tile-content>
    </v-list-tile> -->

      <!-- Candidate Search -->
      <v-list-tile
        v-if="user.primary || managedOpportunities.length"
        key="candidate-search"
        to="/client/applications"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action
          ><v-icon>mdi-account-group</v-icon></v-list-tile-action
        >
        <v-list-tile-content>
          <v-list-tile-title style="height: 30px">
            Candidate search
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Shared -->
      <v-list-tile
        exact
        v-if="!(user.primary || managedOpportunities.length)"
        key="shared"
        to="/client/shared_candidates"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action
          ><v-icon>mdi-share-variant-outline</v-icon></v-list-tile-action
        >
        <v-list-tile-content>
          <v-list-tile-title>Shared With Me</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Opportunities -->
      <v-list-tile
        exact
        v-if="user.primary || managedOpportunities.length"
        key="opportunities"
        to="/client/opportunities"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action><v-icon>mdi-briefcase</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Workspaces</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Campaigns -->
      <v-list-tile
        v-if="user.primary || managedOpportunities.length"
        key="campaigns"
        to="/client/campaigns"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action
          ><v-icon>mdi-clock-start</v-icon></v-list-tile-action
        >
        <v-list-tile-content>
          <v-list-tile-title style="height: 30px">
            Campaigns
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Analytics -->
      <v-list-tile
        key="analytics"
        to="/client/analytics"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action><v-icon>mdi-finance</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title style="height: 30px">
            Analytics
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- My Organization -->
      <v-list-tile
        v-if="organization"
        key="organization"
        :to="`/organizations/${organization.id}`"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action><v-icon>mdi-domain</v-icon></v-list-tile-action>
        <v-list-tile-content
          ><v-list-tile-title
            >Employer page</v-list-tile-title
          ></v-list-tile-content
        >
      </v-list-tile>

      <!-- Users -->
      <v-list-tile
        v-if="user.primary || managedOpportunities.length"
        key="users"
        to="/client/users"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action><v-icon>mdi-account</v-icon></v-list-tile-action>
        <v-list-tile-content
          ><v-list-tile-title>Managers</v-list-tile-title></v-list-tile-content
        >
      </v-list-tile>

      <v-list-tile
        v-if="isPaymentWhitelisted"
        key="billing"
        to="/client/billing"
        @click="toggleDrawer"
        :active-class="themes.client.light.link"
      >
        <v-list-tile-action><v-icon>mdi-credit-card</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Billing</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider v-if="loading || managedOpportunities.length" />
      <v-subheader v-if="loading || managedOpportunities.length">
        Active workspaces
      </v-subheader>
      <!-- Application Trackers -->
      <v-list-tile v-if="loading">
        <v-list-tile-action>
          <v-progress-circular indeterminate size="20" color="grey" />
        </v-list-tile-action>
        <v-list-tile-content
          ><v-list-tile-title>Loading…</v-list-tile-title></v-list-tile-content
        >
      </v-list-tile>
      <v-list-tile
        v-for="(opportunity, i) in managedOpportunities"
        :key="`opportunity-ats-${i}`"
        :to="`/client/opportunities/${opportunity.id}/applications`"
        :active-class="themes.client.light.link"
        @click="toggleDrawer"
        exact
      >
        <v-list-tile-action
          ><v-icon>mdi-clipboard-text</v-icon></v-list-tile-action
        >
        <v-list-tile-content>
          <v-list-tile-title>{{ opportunity.name }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Log out -->
      <v-divider />
      <v-list-tile @click="$emit('logOut')">
        <v-list-tile-action> <v-icon>mdi-logout</v-icon> </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Log out</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
// Helpers
import { mapGetters } from "vuex";

// Vue Component
export default {
  data() {
    return {
      loading: true,
    };
  },
  created() {
    Promise.all([
      this.$store.dispatch("client/organization/fetch"),
      this.$store.dispatch("client/campaigns/fetchAll"),
      this.$store.dispatch("client/opportunities/fetchAll"),
    ]).finally(() => (this.loading = false));
  },
  computed: {
    ...mapGetters({
      campaigns: "client/campaigns/all",
      opportunities: "client/opportunities/all",
      organization: "client/organization/model",
      user: "auth/user",
      isPaymentWhitelisted: "client/payments/isWhitelisted",
    }),
    activeOpportunities() {
      return this.opportunities
        .filter((o) => o.publishedAt && new Date(o.publishedAt) < new Date())
        .filter(
          (o) =>
            !o.commencesAt ||
            (o.commencesAt && new Date(o.commencesAt) > new Date())
        )
        .sort(({ opensAt: a }, { opensAt: b }) => {
          if (new Date(a) > new Date(b)) return -1;
          if (new Date(a) < new Date(b)) return 1;
          return 0;
        });
    },
    managedOpportunities() {
      if (this.user.primary) return this.activeOpportunities;

      return this.activeOpportunities
        .filter((o) => o.managers.some((m) => m.id === this.user.id))
        .sort(({ name: a }, { name: b }) => {
          if (a > b) return 1;
          if (a < b) return -1;
          return 0;
        });
    },
  },
  methods: {
    toggleDrawer() {
      if (this.$vuetify.breakpoint.lgAndDown) this.$store.commit("closeDrawer");
    },
  },
};
</script>
